import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  text: {
    fontSize: '0.833rem',
    marginBottom: '0 !important',
    color: 'inherit',
  },
}));
